import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';

// The drug identity strip this folder's dialogs repeat, so the operator can confirm the NDC
// without looking behind the dialog. Mirrors ManualAdjustmentDialog, plus Manufacturer.
const RecallDialogHeader = ({ title, item, locationCount, closeDisabled, onClose }) => (
  <>
    <Box
      sx={{
        px: 2.5,
        pt: 2,
        pb: 1.25,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
      }}
    >
      <Typography variant='h6' sx={{ fontWeight: 700, lineHeight: 1.2 }}>
        {title}
      </Typography>
      <IconButton
        onClick={onClose}
        disabled={closeDisabled}
        size='small'
        aria-label='close'
        sx={{ mt: -0.25, ml: 1 }}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
    </Box>

    <Box sx={{ px: 2.5, pb: 1.5 }}>
      <Typography
        variant='subtitle1'
        sx={{ fontWeight: 700, lineHeight: 1.4, color: 'text.primary' }}
      >
        {item?.drugName ?? '—'}
        {item?.strength ? ` ${item.strength}` : ''}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.25, flexWrap: 'wrap' }}>
        <Typography variant='body2' color='text.secondary'>
          NDC :
        </Typography>
        <Typography variant='body2' sx={{ fontFamily: 'monospace' }}>
          {item?.ndc ?? '—'}
        </Typography>
        {item?.manufacturer && (
          <>
            <Typography variant='body2' color='text.disabled' sx={{ mx: 0.5 }}>
              |
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              Manufacturer :
            </Typography>
            <Typography variant='body2'>{item.manufacturer}</Typography>
          </>
        )}
        <Typography variant='body2' color='text.disabled' sx={{ mx: 0.5 }}>
          |
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          Locations :
        </Typography>
        <Typography variant='body2'>{locationCount}</Typography>
      </Box>
    </Box>
  </>
);

RecallDialogHeader.propTypes = {
  title: PropTypes.string.isRequired,
  item: PropTypes.shape({
    drugName: PropTypes.string,
    strength: PropTypes.string,
    ndc: PropTypes.string,
    manufacturer: PropTypes.string,
  }),
  locationCount: PropTypes.number.isRequired,
  closeDisabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};
RecallDialogHeader.defaultProps = { item: null, closeDisabled: false };

export default RecallDialogHeader;
